module.exports = __webpack_public_path__ + "static/img/winner_top.2bafb4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winner_top.jpg
// module id = cu1x
// module chunks = 1